import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import "./scss/index.scss";
import "./scss/industry-hot.scss";
import CommonHead from "@/page/index/component/common-head";
import Title from "@/page/index/component/title";
import moIndustry, {
  changeHotActive,
  changeHotType,
  changeTrendActive,
  changeTrendType,
} from "../../store/industry";
import CommonTab from "@/page/index/component/common-Tab";
import CommonTable from "@/page/index/component/common-table";
import IndustryHot from "./component/industry-hot";
import IndustryTrend from "./component/industry-trend";
import Dispach from "./component/dispach";
import IndustryHotAmount from "./component/industry-hot-amount";
import moDemand, { demandInit } from "../../store";
import { isEmpty, round } from "lodash";
import moIndex, { toggleTip } from "@/page/index/store";
import Empty from "@/component/empty";
import moTop from "@/page/index/top/top";
import { exportExcelFile } from "@/tool";
import moUser from "@/store/user";

interface IProps {}
interface IState {}

// 人力需求
const IndustryRecruitment = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    industryType,
    industryActive,
    trendType,
    trendActive,
    trendYear,
    trendMonth,
    trendQuarter,
    hotIndustryList,
    totalHotIndustryList,
    industryTrendList,
  } = moIndustry;

  const tabList = [
    {
      value: "招聘量热度",
      code: "hot",
    },
    {
      value: "招聘量",
      code: "number",
    },
  ];

  const trendTabList = [
    {
      value: "年度",
      code: "year",
    },
    {
      value: "季度",
      code: "quarter",
    },
    {
      value: "月度",
      code: "month",
    },
  ];
  const topList = [
    moTop.updateTime,
    "统计说明：招聘量热度 = 本月招聘量在最近24个月内的招聘量排名（百分位值）。",
    "热度超过90，表示当月招聘量比近两年来90%的时间招聘量要高，行业处于火热期。热度低于50，表示当月招聘量低于近两年来50%的时间，行业处于紧缩期。",
  ];

  const trendList = [
    moTop.updateTime,
    "统计说明：招聘量热度 = 本月招聘量在最近24个月的招聘量排名（百分位值）",
    "招聘薪酬涨幅热度 = 本月招聘薪酬的环比变化率在最近24个月内的环比变化率排名（百分位值）",
  ];

  const getIndustryHot = useMemo(() => {
    let list: any = [];
    if (industryActive === "hot") {
      const res = hotIndustryList?.map((res: any) => {
        const items = [
          res.amount_max,
          res.amount_min,
          res.amount,
          res.amount_rank,
        ];
        return items;
      });
      list = res || [];
      list.unshift([
        "近2年月度最高值",
        "近2年月度最低值",
        "当月招聘量",
        "招聘量热度",
      ]);
    }

    if (industryActive === "number") {
      const result = industryTrendList.slice(-hotIndustryList.length);
      const res = result?.map((res: any) => {
        const items = [
          res.amount_previous,
          res.amount,
          `${round(res.amount_change * 100, 1)}%`,
        ];
        return items;
      });
      list = res || [];
      list.unshift([
        "往期招聘量（个）",
        "当期招聘量（个）",
        "招聘量环比变化率",
      ]);
    }

    return list;
  }, [industryTrendList, hotIndustryList, industryActive]);

  const getTableTrendLeft = useMemo(() => {
    const list: any = [];
    let right: any = [];
    if (trendActive === "year" && !isEmpty(trendYear)) {
      trendYear?.data?.forEach((res: any) => {
        list.push(res.year);
      });
      const res = trendYear?.data?.map((res: any) => {
        const items = [
          res.amount,
          res.amount_change === 0 ? 0 : `${round(res.amount_change * 100, 1)}%`,
          res.salary,
          res.salary_change === 0 ? 0 : `${round(res.salary_change * 100, 1)}%`,
        ];
        return items;
      });
      right = res || [];
      right.unshift([
        "招聘量",
        "招聘量环比变化率",
        "平均月薪（元）",
        "招聘薪酬环比变化率",
      ]);
    }
    if (trendActive === "quarter" && !isEmpty(trendQuarter)) {
      trendQuarter?.forEach((res: any) => {
        list.push(res.time_str);
      });
      const res = trendQuarter?.map((res: any) => {
        const items = [
          res.amount,
          res.amount_change === 0 ? 0 : `${round(res.amount_change * 100, 1)}%`,
          res.salary,
          res.salary_change === 0 ? 0 : `${round(res.salary_change * 100, 1)}%`,
        ];
        return items;
      });
      right = res || [];
      right.unshift([
        "招聘量",
        "招聘量环比变化率",
        "平均月薪（元）",
        "招聘薪酬环比变化率",
      ]);
    }

    if (trendActive === "month" && !isEmpty(trendQuarter)) {
      trendMonth?.forEach((res: any) => {
        list.push(res.time_str);
      });
      const res = trendMonth?.map((res: any) => {
        const items = [
          res.amount,
          res.amount_change === 0 ? 0 : `${round(res.amount_change * 100, 1)}%`,
          res.salary,
          res.salary_change === 0 ? 0 : `${round(res.salary_change * 100, 1)}%`,
        ];
        return items;
      });
      right = res || [];
      right.unshift([
        "招聘量",
        "招聘量环比变化率",
        "平均月薪（元）",
        "招聘薪酬环比变化率",
      ]);
    }
    return { list, right };
  }, [trendMonth, trendQuarter, trendActive, trendYear]);

  const getIndustryLeft = useMemo(() => {
    const list: any = [];
    if (industryActive === "hot") {
      hotIndustryList?.forEach((res: any) => {
        list.push(res.industry);
      });
    }
    if (industryActive === "number") {
      const result = industryTrendList.slice(-hotIndustryList.length);
      result?.forEach((res: any) => {
        list.push(res.industry);
      });
    }
    return list;
  }, [industryTrendList, hotIndustryList, industryActive]);
  const getMaxList = useMemo(() => {
    let list: any = [];
    // 获取最大值
    let max: any = "";
    if (!isEmpty(hotIndustryList)) {
      if (industryActive === "hot") {
        max = hotIndustryList[0].amount_rank;
        hotIndustryList?.forEach((res: any) => {
          if (res.amount_rank > max) {
            max = res.amount_rank;
          }
        });
        list = hotIndustryList?.filter((item: any) => item.amount_rank === max);
      } else {
        max = hotIndustryList[0].amount;
        hotIndustryList?.forEach((res: any) => {
          if (res.amount > max) {
            max = res.amount;
          }
        });
        list = hotIndustryList?.filter((item: any) => item.amount === max);
      }
    }
    return list;
  }, [industryActive, hotIndustryList]);

  const getDispach = useMemo(() => {
    let value = 0;
    let rank = 0;
    let max = 0;
    let mid = 0;
    let min = 0;
    let value1 = 0;
    let rank1 = 0;
    let max1 = 0;
    let mid1 = 0;
    let min1 = 0;
    let time = "";
    if (trendActive === "quarter" && !isEmpty(trendQuarter)) {
      const list = trendQuarter[trendQuarter.length - 1];
      value = list.amount;
      rank = list.amount_rank;
      max = list.amount_max;
      mid = list.amount_median;
      min = list.amount_min;
      value1 = list.salary_change;
      rank1 = list.salary_change_rank;
      max1 = list.salary_change_max;
      mid1 = list.salary_change_median;
      min1 = list.salary_change_min;
      time = list.time_str;
    }
    if (trendActive === "month" && !isEmpty(trendMonth)) {
      const list = trendMonth[trendMonth.length - 1];
      value = list.amount;
      rank = list.amount_rank;
      max = list.amount_max;
      mid = list.amount_median;
      min = list.amount_min;
      value1 = list.salary_change;
      rank1 = list.salary_change_rank;
      max1 = list.salary_change_max;
      mid1 = list.salary_change_median;
      min1 = list.salary_change_min;
      time = list.time_str;
    }
    return {
      value,
      value1,
      rank,
      rank1,
      max,
      max1,
      mid,
      mid1,
      min,
      min1,
      time,
    };
  }, [trendMonth, trendQuarter, trendActive]);

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list :any =[];
    const head :any =['行业',...getIndustryLeft];

    head.forEach((item:any,i:any)=>{
       const items:any =[item,...getIndustryHot[i]];
       list.push(items);
    })
    const merge:any = [];
    console.log(list);
    exportExcelFile(list, merge, '行业招聘热度');
  };

  const exporttable1 = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list :any =[];
    const head :any =['时间',...getTableTrendLeft.list];

    head.forEach((item:any,i:any)=>{
       const items:any =[item,...getTableTrendLeft.right[i]];
       list.push(items);
    })
    const merge:any = [];
    console.log(list);
    exportExcelFile(list, merge, '招聘趋势');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="industry-recruitment-warp" id="contents">
      <section className="tops-title-warp" id="industry">
        <Title title="人力指标" subtitle="行业招聘趋势" />
      </section>
      <section className="hot-warp">
        <CommonHead
          title="行业招聘热度"
          subTitle="行业对比"
          type={industryType}
          bgColor={Color.secondaryColor(0.1)}
          fontColor={Color.secondary}
          contentList={topList}
          onChange={(val: string) => {
            changeHotType(val);
          }}
        />
        <section className="hot-tab">
          <CommonTab
            list={tabList}
            active={industryActive}
            onChange={(val: string) => {
              changeHotActive(val);
            }}
          />
        </section>
        {!isEmpty(industryTrendList) ? (
          <section className="hot-content">
            {industryType === "chart" && (
              <section className="table">
                {industryActive === "hot" && <IndustryHot />}
                {industryActive === "number" && <IndustryHotAmount />}
                <section className="right">
                  <p>解读：</p>
                  <p>
                    {industryActive === "number" &&
                      getMaxList?.map((res: any, i: any) => {
                        return <span key={i}>{res?.time_str}</span>;
                      })}
                    {getMaxList?.map((res: any, i: any) => {
                      return <span key={i}>「{res?.industry}」</span>;
                    })}
                    <span>
                      {industryActive === "hot"
                        ? "招聘热度排行第一，较上个月热度变化"
                        : "招聘量最大"}
                    </span>
                    <span>
                      {industryActive === "hot"
                        ? `「${!isEmpty(getMaxList)&&getMaxList[0]?.amount_rank_change?.toLocaleString()}」`
                        : ""}
                    </span>
                  </p>
                </section>
              </section>
            )}
            {industryType === 'table' && <section onClick={exporttable} className='export-table' style={{marginBottom:'10px',marginTop:0}}>导出excel</section>}
            {industryType === "table" && (
              <CommonTable
                leftList={[[...["行业"], ...getIndustryLeft]]}
                rightList={getIndustryHot}
              />
            )}
          </section>
        ) : (
          <Empty />
        )}
      </section>

      <section className="trend-warp">
        <CommonHead
          title="招聘趋势"
          subTitle={moIndex.industry.name}
          type={trendType}
          bgColor={Color.primaryColor(0.1)}
          fontColor={Color.primary}
          contentList={trendList}
          onChange={(val: string) => {
            changeTrendType(val);
          }}
        />
        <section className="trend-tab">
          <CommonTab
            list={trendTabList}
            active={trendActive}
            onChange={(val: string) => {
              changeTrendActive(val);
            }}
          />
        </section>
        {!isEmpty(hotIndustryList) ? (
          <section className="trend-content">
            {trendType === "chart" && (
              <section className="table">
                <IndustryTrend />
                <section className="right">
                  {trendActive === "year" ? (
                    <section className="year">
                      <p>解读:</p>
                      {trendYear?.overview?.map((res: any, r: any) => {
                        return (
                          <p key={r}>
                            {res.map((item: any, i: any) => {
                              return (
                                <span className={item.mark} key={i}>
                                  {item.mark === "change_rate"
                                    ? `「${round(item.value * 100, 1)}%」`
                                    : item.value}
                                </span>
                              );
                            })}
                          </p>
                        );
                      })}
                    </section>
                  ) : (
                    <section className="dispach-br">
                      <p>解读：招聘量热度（{getDispach.time}）</p>
                      <Dispach
                        title="招聘量"
                        value={getDispach.value}
                        rank={getDispach.rank}
                        max={getDispach.max}
                        mid={getDispach.mid}
                        min={getDispach.min}
                      />
                      <section className="br"></section>
                      <p>解读：招聘量薪酬涨幅热度（{getDispach.time}）</p>
                      <Dispach
                        title="招聘薪酬涨幅"
                        value={getDispach.value1}
                        rank={getDispach.rank1}
                        max={getDispach.max1}
                        mid={getDispach.mid1}
                        min={getDispach.min1}
                        type="ratio"
                      />
                    </section>
                  )}
                </section>
              </section>
            )}
            {trendType === 'table' && <section onClick={exporttable1} className='export-table' style={{marginBottom:'10px',marginTop:0}}>导出excel</section>}
            {trendType === "table" && (
              <CommonTable
                leftList={[[...["时间"], ...getTableTrendLeft.list]]}
                rightList={getTableTrendLeft.right}
              />
            )}
          </section>
        ) : (
          <Empty />
        )}
      </section>
    </section>
  );
};

export default observer(IndustryRecruitment);
